export default __webpack_public_path__ + "static/media/icon_facilidad_prestamo.1761961d.png";